import Menu from "../Menu";
import Footer from "../Footer";
import ScrollProgress from "../ScrollProgress";
function Layout({ children }) {

  return (
    <>
      <ScrollProgress />
      <div className="main-container">
          <Menu />
            {children}
      </div>

      <Footer />
    </>
  );
}

export default Layout;